export enum Deployments {
    CLOUD = 'cloud',
    SERVER = 'server'
}

// Todo: get the right product values
export enum Products {
    JIRA = 'jira',
    CONFLUENCE = 'confluence',
    BITBUCKET = 'bitbucket',
    TRELLO = 'trello',
    JIRA_SERVICE_DESK = 'jira_service_desk',
    JIRA_SOFTWARE = 'jira_software',
    JIRA_CORE = 'jira_core',
    JIRA_BUSINESS = 'jira_business',
    JIRA_WORK_MANAGEMENT = 'jira_work_management'
}
